/**
 * Utility functions for handling image URLs from the API
 */

const API_ORIGIN = process.env.REACT_APP_API_BASE_URL;

/**
 * Converts a relative image URL from the API to a full URL
 * @param imagePath - The image path from the API (could be relative or absolute)
 * @returns Full URL to the image
 */
export const getImageUrl = (imagePath: string | null | undefined): string | null => {
    if (!imagePath) return null;

    // If it's already a full URL (starts with http:// or https://), return as is
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }

    // If it's a relative path, prepend the API origin
    // Remove leading slash if present to avoid double slashes
    const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
    return `${API_ORIGIN}${cleanPath}`;
};

/**
 * Gets a placeholder image URL for when no image is available
 */
export const getPlaceholderImage = (): string => {
    return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%23f3f4f6" width="400" height="300"/%3E%3Ctext fill="%239ca3af" font-family="sans-serif" font-size="18" x="50%25" y="50%25" text-anchor="middle" dominant-baseline="middle"%3ENo Image%3C/text%3E%3C/svg%3E';
};
